// @flow

import * as React from 'react';

/** Component props for an Icon */
export type Props = {|
  /** The icon name */
  name: string,

  /** The css class name */
  className: string,

  /** Child elements */
  children?: React.Node,

  /** Click handler */
  onClick?: () => void,
|};

/**
 * Render a TripAdvisor ui_icon that works in any size and color. See below examples for the variety of
 * icon names that can be used.
 */
const Icon = ({ name, className, children, onClick }: Props) => (
  <span className={`ui_icon ${name} ${className}`} onClick={onClick}>
    {children}
  </span>
);

Icon.defaultProps = {
  className: '',
  children: undefined,
};

// @deprecated: Use @ta/core-ui.icon
export default Icon;
